import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=002ce1d1&scoped=true"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"
import style0 from "./changelog.vue?vue&type=style&index=0&id=002ce1d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ce1d1",
  null
  
)

export default component.exports